import { render, staticRenderFns } from "./MostrarComprobante.vue?vue&type=template&id=db145ba0&scoped=true&"
import script from "./MostrarComprobante.vue?vue&type=script&lang=js&"
export * from "./MostrarComprobante.vue?vue&type=script&lang=js&"
import style0 from "./MostrarComprobante.vue?vue&type=style&index=0&id=db145ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db145ba0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDivider,VIcon,VSheet})
